<template>
  <div class="news-widget">
    <b-skeleton-wrapper :loading="posts === null">
      <template #loading>
        <b-list-group flush>
          <b-list-group-item v-for="n in perPage" :key="$id(n)">
            <b-media no-body>
              <b-media-aside vertical-align="center">
                <b-skeleton-img
                  width="64px"
                  height="56px"
                  no-aspect
                  rounded
                  class="news-thumb"
                ></b-skeleton-img>
              </b-media-aside>
              <b-media-body>
                <b-skeleton
                  height="1.25em"
                  :width="`${getRndInteger(75, 100)}%`"
                ></b-skeleton>
                <b-skeleton
                  height="1.25em"
                  :width="`${getRndInteger(25, 75)}%`"
                ></b-skeleton>
                <div
                  class="d-flex w-100 justify-content-between align-items-baseline"
                >
                  <b-skeleton
                    height="0.75em"
                    :width="`${getRndInteger(15, 20)}%`"
                  ></b-skeleton>
                  <b-skeleton
                    height="0.75em"
                    :width="`${getRndInteger(15, 20)}%`"
                  ></b-skeleton>
                </div>
              </b-media-body>
            </b-media>
          </b-list-group-item>
        </b-list-group>
      </template>
      <b-list-group flush>
        <b-list-group-item
          v-for="post in posts"
          :key="$id(post.slug)"
          :to="{ name: 'SinglePost', params: { postSlug: post.slug } }"
          :variant="post.variant"
        >
          <b-media no-body>
            <b-media-aside v-if="post.image_url" vertical-align="center">
              <picture>
                <source
                  :srcset="darkImgUrl(post.image_url)"
                  media="(prefers-color-scheme: dark)"
                />
                <b-img
                  :src="post.image_url"
                  width="64"
                  height="56"
                  rounded
                  class="news-thumb"
                ></b-img>
              </picture>
            </b-media-aside>
            <b-media-body>
              <h5 class="mb-0">{{ post.title }}</h5>
              <div
                class="d-flex w-100 justify-content-between align-items-baseline"
              >
                <small class="text-muted">
                  In
                  <router-link
                    :to="{
                      name: 'PostsSection',
                      params: { sectionSlug: post.section_slug },
                    }"
                  >
                    {{ post.section_title }}
                  </router-link>
                </small>
                <small class="text-muted">
                  {{ formattedDate(post) }}
                </small>
              </div>
            </b-media-body>
          </b-media>
        </b-list-group-item>
      </b-list-group>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "NewsWidget",
  mixins: [dateFormat],

  props: {
    posts: {
      required: true,
      validator: (prop) => typeof Array.isArray(prop) || prop === null,
    },
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
    perPage: {
      type: Number,
      required: false,
      default: 3,
    },
  },
  data() {
    return {};
  },
  methods: {
    formattedDate(post) {
      return this.formatRelative(post.created_on);
    },
    darkImgUrl(image_url) {
      return image_url.replace(/\.([^.]*)$/, "@dark.$1");
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
};
</script>

<style lang="less">
.news-widget {
  .news-thumb {
    object-fit: cover;
  }
  @media (max-width: 768px) {
    font-size: 14px;
    h5 {
      font-size: 16px;
    }

    .list-group-item {
      padding: 0.25rem 0.75rem;
    }
  }
}
</style>
